import { useLogin } from "@/helpers/useCommonFunctions";
import { Box } from "@dxp-feed/ui/Box";
import { Button } from "@dxp-feed/ui/Button";
import { Text } from "@dxp-feed/ui/Text";

interface IUserLoggedInFallback {
  title: string;
  description: any;
  actionOneText?: string;
  actionTwoText?: string;
  actionOne?: () => void;
  actionTwo?: () => void;
  isShoppingPage?: boolean;
}

const UserLoggedInFallback = ({
  title,
  description,
  actionOne,
  actionOneText,
  actionTwo,
  actionTwoText,
  isShoppingPage = false,
}: IUserLoggedInFallback) => {
  const { loadLogin } = useLogin();

  return (
    <>
      {!isShoppingPage && (
        <Box
          as="div"
          className="w-full grayscale bg-cover bg-no-repeat h-full min-h-[250px] md:min-h-[300px] offersfalbackbg"
        ></Box>
      )}
      <Box
        as="div"
        style={{
          background:
            "linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 35%)",
        }}
        className="absolute top-12 xl:top-20 w-full h-[250px] flex overflow-hidden justify-center items-center manage-list "
      >
        <Box
          as="div"
          className="bg-brandWhite p-4 text-center w-full max-w-[276px] 4xs:max-w-[300px] md:max-w-[383px] m-auto rounded-lg shadow-modalshadow absolute top-[10px] md:top-[45px] left-[-16px] md:left-0 right-0 z-[99] transition-all duration-700 ease-in-out"
        >
          <>
            <Text
              as="span"
              className="font-bold xxss:text-body 4xs:text-base md:text-base font-sans"
            >
              {title}
            </Text>
            {description ? (
              <Text as="p" className="mb-4 text-sm md:text-base">
                {description}
              </Text>
            ) : (
              <Text as="p" className="m-0 h-[10px]">
                &nbsp;
              </Text>
            )}

            <Box
              as="div"
              className="flex justify-between gap-3 flex-col lg:flex-row"
            >
              {actionOne && (
                <Button
                  className="px-6 py-[10px] !text-body !font-normal w-full !border-[1px] !leading-5"
                  variant="primary"
                  aria-label={actionOneText}
                  onClick={actionOne}
                >
                  {actionOneText}
                </Button>
              )}
              {actionTwo && (
                <Button
                  className="!text-body !font-normal w-full !border-[1px] !leading-5 hover:!border-brandSecondary px-6 py-[10px]"
                  variant="outline"
                  onClick={actionTwo}
                  aria-label={actionTwoText}
                >
                  {actionTwoText}
                </Button>
              )}
            </Box>
          </>
        </Box>
      </Box>
    </>
  );
};

export default UserLoggedInFallback;